export const bordereauUpdateRequest = () => ({
    type: 'BORDEREAU_UPDATE_REQUEST'
});

export const bordereauUpdateAttempt = () => {
    return (dispatch) => {
        dispatch(bordereauUpdateRequest());
    }
}